import {
    FilterProps,
    FilterValues,
    KmsTypeFilterDropdown,
    KmsTypeFilterItemDropdown,
} from "@kaltura/mediaspace-shared-types";
import { getDisabledFilters } from "../../vertical-filter-bar/dependencyUtils";
import styled from "@emotion/styled";
import { MenuItem } from "@kaltura/ds-react-components";
import { Check16Icon } from "@kaltura/ds-react-icons";

const StyledWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 0),
}));

const StyledIcon = styled(Check16Icon)(({ theme }) => ({
    fontSize: "1em",
}));

/**
 * responsible for disabling relevant items per current
 * selections (values) <s>and hooking-up the radio filter</s>
 */
export function FieldsSelector(props: FilterProps<KmsTypeFilterDropdown>) {
    const { param, values, defaultValue, onChange } = props;

    let items = props.items;
    let currentSelection = defaultValue;
    if (values) {
        // disable filter items per current selected values
        items = getDisabledFilters(values, [props])[0].items;
        if (values[param]) {
            // this filter is single selection, the value will always be a string, not string[].
            currentSelection = values[param].toString();
        }
    }

    const handleChange = (item: KmsTypeFilterItemDropdown) => {
        const filterValues: FilterValues = { [param]: item.value };
        onChange(filterValues);
    };

    return (
        <StyledWrapper role={"listbox"} aria-labelledby={"search-in-fields-button"}>
            {items.map((item, index) => (
                <MenuItem
                    key={item.value + index}
                    autoFocus={item.value === currentSelection}
                    aria-selected={item.disabled ? undefined : item.value === currentSelection}
                    value={item.value}
                    onClick={() => handleChange(item)}
                    disabled={item.disabled}
                    icon={item.value === currentSelection ? <StyledIcon /> : undefined}
                    role="option"
                >
                    {item.label}
                </MenuItem>
            ))}
        </StyledWrapper>
    );
}

export default FieldsSelector;
